Vue.component('ppcarto-typeahead', {
  props:['type','placeholder','place'],
  data() {
    return {
      settings: ppcarto.settings,
      term: "",
      places: [],
      current: -1,
      selected: null
    }
  },
  template: `
  <div class="ppcarto-typeahead">
    <div class="preview">{{preview()}}</div>
    <input autocomplete="off" :placeholder="placeholder" v-model="term" ref="input"
    @keydown.down="down()"
    @keydown.up="up()"
    @keydown.esc="reset()"
    @blur="check()"
    v-on:keyup.enter="select()" />
    <ul v-show="places.length > 0">
      <li v-for="(place, index) in places" :class="{active: index == current}"
      @mousedown="select()" @mousemove="current = index">
        <span v-text="place.longName"></span>
      </li>
    </ul>
  </div>
  `,
  methods: {
    getPlaces: _.throttle(function() {
      let params = {
        key: "T4zfoM0y",
        query: this.term,
        countryCode: 'AT',
        languageCode: 'en'
      }

      this.$http.get('https://free.rome2rio.com/api/1.4/json/Autocomplete',{params: params}).then((response) => {
        if(response.data.places) {
          if(this.type == "destination") {
            this.places = _.filter(response.data.places, place => { return place.countryCode == "AT" && place.regionCode == "2" })
          } else {
            this.places = response.data.places;
          }
        } else {
          this.places = [];
        }
      })

    },500),
    down() {
      if(this.places.length > 0) {
        if(this.current < this.places.length - 1) {
            this.current = this.current + 1;
        } else {
          this.current = 0;
        }
      } else {
        this.current = -1;
      }
    },
    up() {
      if(this.places.length > 0) {
        if(this.current > 0) {
            this.current = this.current - 1;
        } else {
          this.current = this.places.length - 1;
        }
      }
    },
    select() {
      if(this.places.length > 0) {
        this.selected = this.places[this.current];
        this.places = [];
      }
      if(this.selected) {
        this.term = this.selected.longName;
        this.$refs.input.blur();
        this.$emit('select', { type: this.type, place: this.selected });
      }
    },
    check(){
      if(this.places.length > 0) {
        this.selected = this.places[0];
        this.places = [];
      } else {
        this.term = ""
      }
      if(this.selected) {
        this.term = this.selected.longName;
        this.$emit('select', { type: this.type, place: this.selected });
      }
    },
    reset(){
      this.places = [];
      this.term = "";
      this.selected = null;
    },
    preview(){
      if(this.places.length > 0) {
        return this.places[0].longName;
      } else {
        return ""
      }

    }
  },
  watch: {
    place(place) {
      //console.log(this.type,place);
      if(place) {
        this.selected = place;
        this.term = this.selected.longName;
      }
    },
    term(term) {
      if(this.selected && this.selected.longName == term) {
        return;
      }
      if(term.length > 2) {
        this.getPlaces();
      }
    }
  }


})
